import {
  AWARD,
  BADGE,
  BILLABLE,
  JOB,
  MILESTONE,
  PROJECT,
  REWARD,
  SUPPORT,
} from "icons";

export const NOTIFICATION_ENDPOINT = "notifications";

export const COLLECTION_ICONS = {
  jobs: JOB,
  job_extensions: JOB,
  milestones: MILESTONE,
  billables: BILLABLE,
  awards: AWARD,
  badges: BADGE,
  rewards: REWARD,
  projects: PROJECT,
  tickets: SUPPORT,
};

export const NOTIFICATION_FIELDS = [
  "id",
  "status",
  "collection",
  "subject",
  "message",
  "item",
  "timestamp",
  "type",
];

export const INBOX_NAV_ITEMS = [
  { path: "/inbox", label: "Pending", id: "pending" },
  { path: "/inbox/cleared", label: "Cleared", id: "cleared" },
];
